import { EditableContent } from '../../edit/EditableContent';
import { pickBlockField } from '../../lib/localized';
import { parseRouteStops } from '../../lib/parseLabeledLines';
import type { BlockRenderProps } from '../../types';

/** Wide route board — day tiles; each place opens a maps location link. */
export function WeeklyScheduleRouteBoard({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const supporting = pickBlockField(block.content, 'supporting', locale);
  const scheduleRaw = pickBlockField(block.content, 'schedule', locale);
  const rows = parseRouteStops(scheduleRaw);
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-route-board', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      data-registry-key={block.registryBlockKey}
      id="schedule"
    >
      <div className="ws-route-board__inner">
        <header className="ws-route-board__intro">
          <EditableContent
            as="h2"
            fieldKey="sectionTitle"
            editable={editable}
            activeEditTarget={target}
            className="ws-route-board__title"
          >
            {sectionTitle}
          </EditableContent>
          {supporting || editable ? (
            <EditableContent
              fieldKey="supporting"
              editable={editable}
              activeEditTarget={target}
              className="ws-route-board__supporting"
            >
              {supporting}
            </EditableContent>
          ) : null}
        </header>
        {editable ? (
          <EditableContent
            fieldKey="schedule"
            editable={editable}
            activeEditTarget={target}
            className="ws-route-board__editor"
          >
            {scheduleRaw}
          </EditableContent>
        ) : (
          <ol className="ws-route-board__grid">
            {rows.map((row, index) => (
              <li key={`${row.day}-${index}`} className="ws-route-board__tile">
                <span className="ws-route-board__day">{row.day}</span>
                {row.place ? (
                  row.href ? (
                    <a
                      className="ws-route-board__place"
                      href={row.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {row.place}
                    </a>
                  ) : (
                    <span className="ws-route-board__place">{row.place}</span>
                  )
                ) : null}
              </li>
            ))}
          </ol>
        )}
      </div>
    </section>
  );
}
